import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import {
  $intro,
  $share,
  $tips,
  $message
} from './components/popupLayout'

Vue.mixin({
  methods: {
    $intro,
    $share,
    $tips,
    $message
  }
})

Vue.use(Viewer)


Vue.prototype.$bus = new Vue()
Vue.prototype.$cdn = 'http://4d-tjw.oss-cn-shenzhen.aliyuncs.com/syms/'


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
